import React from "react";
import ReactDOM from "react-dom";
import { Flash as FlashComponent, FlashType } from "components/shared/flash";

function addSingleFlash(message: string, type: FlashType) {
  ReactDOM.render(
    <FlashComponent type={type} message={message} />,
    document.getElementsByClassName("flash-wrapper")[0]
  );
}

const Flash = {
  remove() {
    ReactDOM.unmountComponentAtNode(
      document.getElementsByClassName("flash-wrapper")[0]
    );
  },

  setError: function (message: string) {
    Flash.set(message, "error");
  },

  setPending: function (message: string) {
    Flash.set(message, "pending");
  },

  setSuccess: function (message: string) {
    Flash.set(message, "success");
  },

  set: function (object: string, type: FlashType) {
    Flash.remove();
    addSingleFlash(object, type);
  },
};

export default Flash;
